export const newClientEscalation = [
  {
    key: "disputeDetails",
    title: "Dispute Details",
    fields: [
      {
        key: "eClientName",
        label: "Client",
        placeholder: "Enter the Client Name",
        errorMessage: "Client Name is required",
        type: "input",
      },
      {
        key: "eClientSpocEmail",
        label: "Client SPOC Email",
        placeholder: "Enter the Client SPOC Email",
        errorMessage: "Client SPOC Email is required",
        type: "input",
        validate: "email",
      },
      {
        key: "eEmpID",
        label: "Emp ID",
        placeholder: "Enter the Emp ID",
        errorMessage: "Emp ID is required",
        type: "number",
      },
      {
        key: "eFinancialImpact",
        label: "Financial Impact",
        placeholder: "Enter the Financial Impact",
        errorMessage: "Financial Impact is required",
        type: "input",
      },
      {
        key: "eAgentName",
        label: "Agent",
        placeholder: "Enter the Agent Name",
        errorMessage: "Agent Name is required",
        type: "input",
      },
      {
        key: "eAuditorName",
        label: "Auditor",
        placeholder: "Enter the Auditor Name",
        errorMessage: "Auditor Name is required",
        type: "input",
      },
      {
        key: "eReportingTlName",
        label: "Reporting TL",
        placeholder: "Enter the Reporting TL Name",
        errorMessage: "Reporting TL is required",
        type: "input",
      },
      {
        key: "eDepartmentName",
        label: "Department",
        placeholder: "Enter the Department Name",
        errorMessage: "Department Name is required",
        type: "input",
      },
      {
        key: "eProcessName",
        label: "Process",
        placeholder: "Enter the Process Name",
        errorMessage: "Process Name is required",
        type: "input",
      },
      {
        key: "eErrorRaiseDate",
        label: "Error Raise Date",
        placeholder: "Choose a Date",
        errorMessage: "Error raise date is required",
        type: "date",
      },
    ],
  },
  {
    key: "transactionDetails",
    title: "Transaction Details",
    fields: [
      {
        key: "eTransactionId",
        label: "Transaction ID",
        placeholder: "Enter the Transaction ID",
        errorMessage: "Transaction ID is required",
        type: "input",
      },
      {
        key: "eTransactionDate",
        label: "Transaction Date",
        placeholder: "Choose a Date",
        errorMessage: "Transaction Date is required",
        type: "date",
      },
    ],
  },
  {
    key: "errorDetails",
    title: "Error Details",
    fields: [
      {
        key: "eErrorArea",
        label: "Error Area",
        placeholder: "Enter the Error Area",
        errorMessage: "Error Area is required",
        type: "input",
      },
      {
        key: "eErrorType",
        label: "Error Type",
        placeholder: "Enter the Error Type",
        errorMessage: "Error Type is required",
        type: "input",
      },
      {
        key: "eErrorDescription",
        label: "Error Description",
        placeholder:
          "Free text, write in detail, what was done , what went wrong , what is the right process. If error is reversed, explain reason also.",
        errorMessage: "Error description is required",
        type: "textarea",
      },
      {
        key: "eErrorInvestigationRemarks",
        label: "Error investigation remarks",
        placeholder: "Enter investigation remarks here",
        errorMessage: "",
        type: "textarea",
      },
      {
        key: "eErrorImpact",
        label: "Error Impact",
        placeholder: "Choose an error impact",
        errorMessage: "Error impact is required",
        type: "select",
        options: [
          { value: "LOW", label: "LOW" },
          { value: "MEDIUM", label: "MEDIUM" },
          { value: "HIGH", label: "HIGH" },
        ],
      },
      {
        key: "eErrorStatus",
        label: "Error Status",
        placeholder: "Choose an error status",
        errorMessage: "Error status is required",
        type: "select",
        options: [
          { value: "Accepted", label: "Accepted" },
          { value: "Not Accepted", label: "Not Accepted" },
          { value: "Reversed", label: "Reversed" },
          { value: "Under Dispute", label: "Under Dispute" },
        ],
      },
      {
        key: "eDayoftheweek",
        label: "Day of the Week",
        placeholder: "Enter day of the week",
        errorMessage: "Day of the week is required",
        type: "readonly",
      },
      {
        key: "eAgentTenure",
        label: "Agent Tenure",
        placeholder: "Choose an agent tenure",
        errorMessage: "Agent tenure is required",
        type: "select",
        options: [
          { value: "Less than 90 days", label: "Less than 90 days" },
          { value: "90 to 179 days", label: "90 to 179 days" },
          { value: "180 or more days", label: "180 or more days" },
        ],
      },
      {
        key: "eFeedbackdate",
        label: "Feedback Date",
        placeholder: "Choose a Date",
        errorMessage: "Feedback date is required",
        type: "date",
      },
      {
        key: "eRepeatedError",
        label: "Repeated Error",
        placeholder: "Choose an repeated error",
        errorMessage: "Repeated error is required",
        type: "select",
        options: [
          {
            value: "No similar error reported by the client in past 3 months",
            label: "No similar error reported by the client in past 3 months",
          },
          {
            value: "Similar error reported by the client in past 3 months",
            label: "Similar error reported by the client in past 3 months",
          },
        ],
      },
      {
        key: "eCorrectiveActionTaken",
        label: "Corrective Action Taken",
        placeholder: "Enter corrective action taken",
        errorMessage: "Corrective action taken is required",
        type: "input",
      },
    ],
  },
  {
    key: "rcaDetails",
    title: "RCA Details",
    fields: [
      {
        key: "rcaLevelOne",
        label: "RCA Level One",
        placeholder: "Choose an RCA Level One",
        errorMessage: "RCA Level One is required",
        type: "select",
        options: [
          { value: "agent", label: "Agent" },
          { value: "client", label: "Client" },
          { value: "process", label: "Process" },
          { value: "technology", label: "Technology" },
        ],
      },
      {
        key: "rcaLevelTwo",
        label: "RCA Level Two",
        placeholder: "Choose RCA Level Two",
        errorMessage: "RCA Level Two is required",
        type: "select",
        optionsByParent: {
          agent: [
            {
              value: "unfocusedlossoffocus",
              label: "Unfocused / Loss of Focus",
            },
            {
              value: "insufficientproductknowledge",
              label: "Insufficient Product Knowledge",
            },
            { value: "communicationgap", label: "Communication Gap" },
            { value: "willbehavioralissue", label: "Will/Behavioral Issue" },
            { value: "rushed", label: "Rushed" },
            { value: "forgetfulness", label: "Forgetfulness" },
            { value: "wfh", label: "WFH" },
          ],
          client: [
            { value: "clientknowledgegap", label: "Knowledge Gap" },
            { value: "updatenotshared", label: "Update Not Shared" },
            { value: "nofeedbackmechanism", label: "No Feedback Mechanism" },
            {
              value: "communicationbreakdown",
              label: "Communication Breakdown",
            },
            { value: "unstructuredtraining", label: "Unstructured Training" },
            {
              value: "lackofreviewscoaching",
              label: "Lack of Reviews/Coaching",
            },
          ],
          process: [
            { value: "processknowledgegap", label: "Knowledge Gap" },
            { value: "sopdeficiency", label: "SOP Deficiency" },
            {
              value: "inadequatesupportcoaching",
              label: "Inadequate support/coaching",
            },
            {
              value: "notaskplanningtracking",
              label: "No task planning/tracking",
            },
            { value: "scenarionotcovered", label: "Scenario not covered" },
          ],
          technology: [
            { value: "technicalissue", label: "Technical Issue" },
            { value: "hardwareissues", label: "Hardware Issues" },
            { value: "accessories", label: "Accessories" },
            { value: "inadequaitsupport", label: "Inadequate IT Support" },
          ],
        },
      },
      {
        key: "rcaLevelThree",
        label: "RCA Level Three",
        placeholder: "Choose RCA Level Three",
        errorMessage: "RCA Level Three is required",
        type: "select",
        optionsByParent: {
          unfocusedlossoffocus: [
            {
              value: "unfocusedlossoffocusenvironmentalfactors",
              label: "Environmental Factors",
            },
            {
              value: "unfocusedlossoffocuspersonalfactors",
              label: "Personal Factors",
            },
            {
              value: "motivationandengagement",
              label: "Motivation and Engagement",
            },
          ],
          insufficientproductknowledge: [
            {
              value: "trainingrelatedcauses",
              label: "Training-Related Causes",
            },
            {
              value: "unawareofprocesschanges",
              label: "Unaware of process changes",
            },
          ],
          communicationgap: [
            { value: "poorcommunication", label: "Poor communication" },
            {
              value: "lessconfidenceinnewscenarios",
              label: "Less confidence in new scenarios",
            },
            {
              value: "unwillingtoclarifydoubts",
              label: "Unwilling to clarify doubts",
            },
            {
              value: "mixedorunclearmessages",
              label: "Mixed or unclear messages",
            },
            {
              value: "verbalcommunication",
              label: "Verbal communication",
            },
            {
              value: "backupagent",
              label: "Back up Agent",
            },
          ],
          willbehavioralissue: [
            {
              value: "poorattitude",
              label: "Poor attitude",
            },
            {
              value: "procrastination",
              label: "Procrastination",
            },
            {
              value: "lackofaccountability",
              label: "Lack of accountability",
            },
            {
              value: "notserioustowardresponsibilities",
              label: "Not serious toward responsibilities",
            },
            {
              value: "healthemotionalstress",
              label: "Health / Emotional Stress",
            },
          ],
          rushed: [
            { value: "negligence", label: "Negligence" },
            {
              value: "timepressuredeadlineworkload",
              label: "Time pressure/Deadline/ Workload",
            },
          ],
          forgetfulness: [
            {
              value: "updatesentviachatonly",
              label: "Update sent via chat only",
            },
            {
              value: "excessivemultitasking",
              label: "Excessive multitasking",
            },
            {
              value: "forgetfulnesspersonalfactors",
              label: "Personal Factors",
            },
          ],
          wfh: [
            { value: "singlescreen", label: "Single Screen" },
            { value: "electricityinternet", label: "Electricity / Internet" },
            {
              value: "wfhenvironmentalfactors",
              label: "Environmental Factors",
            },
          ],
          clientknowledgegap: [
            { value: "sopdeviation", label: "SOP deviation" },
            { value: "unclearrequirements", label: "Unclear Requirements" },
          ],
          updatenotshared: [
            {
              value: "teamunawareofnewflow",
              label: "Team unaware of new flow",
            },
            {
              value: "noformalupdateprocess",
              label: "No Formal Update Process",
            },
          ],
          nofeedbackmechanism: [
            {
              value: "noclarityonerrorsimprovements",
              label: "No clarity on errors/improvements",
            },
            {
              value: "nofeedbackchannelsestablished",
              label: "No Feedback Channels Established",
            },
          ],
          communicationbreakdown: [
            { value: "delayinresponse", label: "Delay in response" },
            {
              value: "misinterpretationofinformation",
              label: "Misinterpretation of Information",
            },
          ],
          unstructuredtraining: [
            { value: "incompletetraining", label: "Incomplete training" },
            {
              value: "nodefinedtrainingplan",
              label: "No Defined Training Plan",
            },
          ],
          lackofreviewscoaching: [
            {
              value: "lackofperformancefeedback",
              label: "Lack of performance feedback",
            },
            {
              value: "infrequentornoperformancereviews",
              label: "Infrequent or No Performance Reviews",
            },
          ],
          processknowledgegap: [
            { value: "sopnotdefined", label: "SOP not defined" },
            {
              value: "poorknowledgetransfer",
              label: "Poor knowledge transfer",
            },
            {
              value: "inadequatedocumentation",
              label: "Inadequate Documentation",
            },
          ],
          sopdeficiency: [
            { value: "sopnotavailable", label: "SOP not available" },
            {
              value: "sopsnotupdatedregularly",
              label: "SOPs Not Updated Regularly",
            },
          ],
          inadequatesupportcoaching: [
            {
              value: "taskexecutionconfusion",
              label: "Task execution confusion",
            },
            {
              value: "lackofmentorshipprogram",
              label: "Lack of Mentorship Program",
            },
          ],
          notaskplanningtracking: [
            { value: "notimeownership", label: "No time ownership" },
            {
              value: "absenceoftaskmanagementtools",
              label: "Absence of Task Management Tools",
            },
          ],
          scenarionotcovered: [
            {
              value: "unaddressededgecases",
              label: "Unaddressed edge cases",
            },
            {
              value: "lackofcontingencyplans",
              label: "Lack of Contingency Plans",
            },
          ],
          technicalissue: [
            { value: "systembugsglitches", label: "System bugs/glitches" },
            {
              value: "systemdowntimeoutages",
              label: "System downtime/outages",
            },
          ],
          hardwareissues: [
            {
              value: "performanceinternetissues",
              label: "Performance/internet issues",
            },
            { value: "serverissues", label: "Server issues" },
            { value: "agingequipment", label: "Aging Equipment" },
          ],
          accessories: [
            {
              value: "keyboardmousemonitorissues",
              label: "Keyboard/Mouse/Monitor issues",
            },
            {
              value: "incompatibledevices",
              label: "Incompatible Devices",
            },
          ],
          inadequaitsupport: [
            {
              value: "lackoftroubleshooting",
              label: "Lack of troubleshooting",
            },
            {
              value: "slowresponsetime",
              label: "Slow Response Time",
            },
          ],
        },
      },
      {
        key: "rcaLevelFour",
        label: "RCA Level Four",
        placeholder: "Choose RCA Level Four",
        errorMessage: "RCA Level Four is required",
        type: "select",
        optionsByParent: {
          unfocusedlossoffocusenvironmentalfactors: [
            {
              value: "excessivenoiseordistractionsinthe workplace",
              label: "Excessive noise or distractions in the workplace",
            },
            {
              value: "poorlightingoruncomfortable workspace",
              label: "Poor lighting or uncomfortable workspace",
            },
            {
              value: "frequentinterruptionsemailscallscoworkers",
              label: "Frequent interruptions (emails, calls, coworkers)",
            },
          ],
          unfocusedlossoffocuspersonalfactors: [
            {
              value: "fatigueorlackofsleep",
              label: "Fatigue or lack of sleep",
            },
            {
              value: "stressanxietyorpersonalissues",
              label: "Stress, anxiety, or personal issues",
            },
            {
              value: "healthproblemsorpoornutrition",
              label: "Health problems or poor nutrition",
            },
          ],
          motivationandengagement: [
            {
              value: "lackofinterestorpassioninthework",
              label: "Lack of interest or passion in the work",
            },
            {
              value: "feelingundervaluedorunrecognized",
              label: "Feeling undervalued or unrecognized",
            },
            {
              value: "pooralignmentbetweenpersonalvaluesandjobrole",
              label: "Poor alignment between personal values and job role",
            },
          ],
          trainingrelatedcauses: [
            {
              value: "insufficienttimefortraining",
              label: "Insufficient Time for Training",
            },
            {
              value: "nostructuredonboardingprogram",
              label: "No structured onboarding program",
            },
            {
              value: "sopnotrevisedafterupdates",
              label: "SOP not revised after updates",
            },
            {
              value: "newscenariosrareoccurredscenarios",
              label: "New Scenarios/ rare occurred scenarios",
            },
          ],
          unawareofprocesschanges: [
            {
              value: "missedupdatemeetingssopnotfollowed",
              label: "Missed update meetings, SOP not followed",
            },
          ],
          poorcommunication: [
            {
              value: "productupdatesnotsharedpromptly",
              label: "Product updates not shared promptly",
            },
          ],
          lessconfidenceinnewscenarios: [
            {
              value: "languagebarrierpoorcommunicationlackofunderstanding",
              label:
                "Language barrier / Poor communication / Lack of understanding",
            },
          ],
          unwillingtoclarifydoubts: [
            {
              value: "reluctancetoaskquestionsoradmitconfusion",
              label: "Reluctance to ask questions or admit confusion",
            },
            {
              value: "poorrelationshipwithsupervisors",
              label: "Poor relationship with supervisors",
            },
            {
              value: "lackofinterestorpassioninthework",
              label: "Lack of interest or passion in the work",
            },
          ],
          mixedorunclearmessages: [
            {
              value: "inconsistentinformationsharedpoorlisteningskills",
              label: "Inconsistent information shared, Poor listening skills",
            },
          ],
          verbalcommunication: [
            {
              value: "misinterpretedtheinformationupdateshared",
              label: "Misinterpreted the information/update shared",
            },
          ],
          backupagent: [
            {
              value: "noproperupdateoftaskbyprocessoragentaligned",
              label: "No Proper update of Task by Processor/Agent aligned",
            },
          ],
          poorattitude: [
            {
              value: "negativemindsetresistancetochange",
              label: "Negative mindset, resistance to change",
            },
            { value: "overconfidence", label: "Overconfidence" },
          ],
          procrastination: [
            {
              value: "delayingtasksduetofearoffailureorlowinterest",
              label: "Delaying tasks due to fear of failure or low interest",
            },
          ],
          lackofaccountability: [
            {
              value: "avoidingresponsibilityblamingothers",
              label: "Avoiding responsibility, blaming others",
            },
          ],
          healthemotionalstress: [
            {
              value: "anxietyburnoutdisengagement",
              label: "Anxiety, burnout, disengagement",
            },
          ],
          notserioustowardresponsibilities: [
            {
              value: "feelsworkisunimportantorunrewarding               ",
              label: "Feels work is unimportant or unrewarding              ",
            },
            { value: "lackofmotivation", label: "Lack of motivation" },
          ],
          negligence: [
            { value: "hastecarelessness", label: "Haste /carelessness" },
          ],
          timepressuredeadlineworkload: [
            { value: "lastminuterush", label: "Last-minute rush" },
            { value: "poortimemanagement", label: "Poor time management" },
            {
              value: "stressfromleadershippushingforspeedoverquality",
              label: "Stress from leadership pushing for speed over quality",
            },
            {
              value: "highworkloadorunderstaffing",
              label: "High workload or understaffing",
            },
          ],
          updatesentviachatonly: [
            {
              value: "nodocumentationofupdate",
              label: "No documentation of update",
            },
          ],
          excessivemultitasking: [
            { value: "urgentworkcamealong", label: "Urgent work came along" },
            { value: "understaffing", label: "Understaffing" },
          ],
          forgetfulnesspersonalfactors: [
            { value: "stressoranxiety", label: "Stress or anxiety" },
            {
              value: "fatigueorlackofsleep",
              label: "Fatigue or lack of sleep",
            },
          ],
          singlescreen: [
            {
              value: "unabletocopupwithmultipletabs",
              label: "Unable to cop up with Multiple Tabs",
            },
          ],
          electricityinternet: [{ value: "disruption", label: "Disruption" }],
          wfhenvironmentalfactors: [
            {
              value: "excessivenoiseordistractions",
              label: "Excessive noise or distractions",
            },
            {
              value: "uncomfortableworkspace",
              label: "Uncomfortable workspace",
            },
          ],
          sopdeviation: [
            { value: "outdatedprocedures", label: "Outdated procedures" },
          ],
          unclearrequirements: [
            {
              value: "poorcommunicationofneeds",
              label: "Poor Communication of Needs",
            },
          ],
          teamunawareofnewflow: [
            {
              value: "missedcommunicationinfosilos",
              label: "Missed communication, info silos",
            },
          ],
          noformalupdateprocess: [
            {
              value: "lackofscheduledclientcommunication",
              label: "Lack of Scheduled Client Communication",
            },
          ],
          noclarityonerrorsimprovements: [
            {
              value: "lackofmetricsnoimprovementcycle",
              label: "Lack of metrics, no improvement cycle",
            },
          ],
          nofeedbackchannelsestablished: [
            {
              value: "absenceoffeedbacktoolsorplatforms",
              label: "Absence of Feedback Tools or Platforms",
            },
          ],
          delayinresponse: [
            {
              value: "lateemailsslowfeedback",
              label: "Late emails, slow feedback",
            },
          ],
          misinterpretationofinformation: [
            {
              value: "lackofclarificationprocesses",
              label: "Lack of Clarification Processes",
            },
          ],
          incompletetraining: [
            {
              value: "patchyonboardingnofollowup",
              label: "Patchy onboarding, no follow-up",
            },
          ],
          nodefinedtrainingplan: [
            {
              value: "lackoftrainingownership",
              label: "Lack of Training Ownership",
            },
          ],
          lackofperformancefeedback: [
            {
              value: "lowmoralelackofrecognition",
              label: "Low morale, lack of recognition",
            },
          ],
          infrequentornoperformancereviews: [
            {
              value: "nostandardreviewcriteria",
              label: "No Standard Review Criteria",
            },
          ],
          sopnotdefined: [
            {
              value: "missinginsufficientdocumentation",
              label: "missinginsufficientdocumentation",
            },
          ],
          poorknowledgetransfer: [
            {
              value: "incompleteonboardingnohandsonpractice",
              label: "Incomplete onboarding, No Hands-On Practice",
            },
          ],
          inadequatedocumentation: [
            {
              value: "outdatedormissingdocuments",
              label: "Outdated or Missing Documents",
            },
          ],
          sopnotavailable: [
            {
              value: "documentoutdatedornotdistributedsourcesscattered",
              label: "Document outdated or not distributed / Sources scattered",
            },
          ],
          sopsnotupdatedregularly: [
            { value: "lackofreviewcycle", label: "Lack of Review Cycle" },
          ],
          taskexecutionconfusion: [
            { value: "noescalationpath", label: "No escalation path" },
          ],
          lackofmentorshipprogram: [
            {
              value: "limitedexperiencedstaffforguidance",
              label: "Limited Experienced Staff for Guidance",
            },
          ],
          notimeownership: [
            { value: "undefinedpriorities", label: "Undefined priorities" },
          ],
          absenceoftaskmanagementtools: [
            {
              value: "nodefinedownershipoftasktracking",
              label: "No Defined Ownership of Task Tracking",
            },
          ],
          unaddressededgecases: [
            {
              value: "frequentbreaksinworkflow",
              label: "Frequent breaks in workflow",
            },
          ],
          lackofcontingencyplans: [
            {
              value: "infrequentriskassessment",
              label: "Infrequent Risk Assessment",
            },
          ],
          systembugsglitches: [
            {
              value: "itticketdelaysrecurringbugsdelayedbug Fixes",
              label: "IT ticket delays, recurring bugs, Delayed Bug Fixes",
            },
          ],
          systemdowntimeoutages: [
            { value: "serviceinterruptions", label: "Service interruptions" },
          ],
          performanceinternetissues: [
            {
              value: "lowbandwidthlaggingdevices",
              label: "Low bandwidth, lagging devices",
            },
          ],
          serverissues: [
            {
              value: "hardwareupgradesdepreciation",
              label: "Hardware upgrades/depreciation",
            },
          ],
          agingequipment: [
            {
              value: "lackofscheduledmaintenance",
              label: "Lack of Scheduled Maintenance",
            },
          ],
          keyboardmousemonitorissues: [
            {
              value: "inputerrorsslowreplacement",
              label: "Input errors, slow replacement",
            },
          ],
          incompatibledevices: [
            {
              value: "nostandardizationofaccessories",
              label: "No Standardization of Accessories",
            },
          ],
          lackoftroubleshooting: [
            { value: "resourcingissues", label: "Resourcing issues" },
          ],
          slowresponsetime: [
            {
              value: "insufficientitstaffing",
              label: "Insufficient IT Staffing",
            },
          ],
        },
      },
    ],
  },
];

export const internalErrorRca = [
  {
    key: "errorDetails",
    title: "Error Details",
    fields: [
      {
        key: "eErrorRaiseDate",
        label: "Error Raise Date",
        placeholder: "Choose a Date",
        errorMessage: "Error raise date is required",
        type: "readonly",
      },
      {
        key: "eFeedbackdate",
        label: "Feedback Date",
        placeholder: "Choose a Date",
        errorMessage: "Feedback date is required",
        type: "date",
      },
      {
        key: "eErrorDescription",
        label: "Error Description",
        placeholder:
          "Free text, write in detail, what was done , what went wrong , what is the right process. If error is reversed, explain reason also.",
        errorMessage: "Error description is required",
        type: "textarea",
      },
      {
        key: "eErrorImpact",
        label: "Error Impact",
        placeholder: "Choose an error impact",
        errorMessage: "Error impact is required",
        type: "select",
        options: [
          { value: "HIGH", label: "HIGH" },
          { value: "MEDIUM", label: "MEDIUM" },
          { value: "LOW", label: "LOW" },
        ],
      },
      {
        key: "eErrorInvestigationRemarks",
        label: "Error investigation remarks",
        placeholder: "Enter investigation remarks here",
        errorMessage: "",
        type: "textarea",
      },
      {
        key: "eErrorStatus",
        label: "Error Status",
        placeholder: "Choose an error status",
        errorMessage: "Error status is required",
        type: "select",
        options: [
          { value: "Accepted", label: "Accepted" },
          { value: "Under Discussion", label: "Under Discussion" },
        ],
      },
      {
        key: "eAdvisorShiftDuringError",
        label: "Advisor Shift During Error",
        placeholder: "Choose an Advisor shift during error",
        errorMessage: "Advisor shift during error is required",
        type: "select",
        options: [
          { value: "Night Shift", label: "Night Shift" },
          { value: "Morning Shift", label: "Morning Shift" },
          { value: "Mid-Shift", label: "Mid-Shift" },
        ],
      },
      {
        key: "eErroronweekdayweekend",
        label: "Error on Weekday/Weekend",
        placeholder: "Enter an error on Weekday/Weekend",
        errorMessage: "Error on Weekday/Weekend is required",
        type: "readonly",
      },
      {
        key: "eDayoftheweek",
        label: "Day of the Week",
        placeholder: "Enter day of the week",
        errorMessage: "Day of the week is required",
        type: "readonly",
      },
      {
        key: "eAgentTenure",
        label: "Agent Tenure",
        placeholder: "Choose an agent tenure",
        errorMessage: "Agent tenure is required",
        type: "select",
        options: [
          { value: "Less than 90 days", label: "Less than 90 days" },
          { value: "90 to 179 days", label: "90 to 179 days" },
          { value: "180 or more days", label: "180 or more days" },
        ],
      },
      {
        key: "eFeedbackStatus",
        label: "Feedback Status",
        placeholder: "Choose a feedback status",
        errorMessage: "Feedback status is required",
        type: "select",
        options: [
          {
            value: "Closed",
            label: "Closed",
          },
          {
            value: "Pending",
            label: "Pending",
          },
          {
            value: "On leave",
            label: "On leave",
          },
        ],
      },
      {
        key: "eFeedbackShared",
        label: "Feedback shared in how many hrs after accepting error",
        placeholder:
          "Choose a feedback shared in how many hrs after accepting error",
        errorMessage:
          "Feedback shared in how many hrs after accepting error is required",
        type: "select",
        options: [
          {
            value: "Within 2 hrs",
            label: "Within 2 hrs",
          },
          {
            value: "Within 6 hrs",
            label: "Within 6 hrs",
          },
          {
            value: "Within 12 hrs",
            label: "Within 12 hrs",
          },
          {
            value: "Within 24 hrs",
            label: "Within 24 hrs",
          },
          {
            value: "Within 48 hrs",
            label: "Within 48 hrs",
          },
        ],
      },
      {
        key: "eRepeatedError",
        label: "Repeated Error",
        placeholder: "Choose an repeated error",
        errorMessage: "Repeated error is required",
        type: "select",
        options: [
          {
            value: "No similar error reported by the client in past 3 months",
            label: "No similar error reported by the client in past 3 months",
          },
          {
            value: "Similar error reported in past 3 months",
            label: "Similar error reported in past 3 months",
          },
        ],
      },
      {
        key: "eCorrectiveActionTaken",
        label: "Corrective Action Taken",
        placeholder: "Enter corrective action taken",
        errorMessage: "Corrective action taken is required",
        type: "input",
      },
      {
        key: "ePreventiveActionTaken",
        label: "Preventive Action Taken (Action Plan)",
        placeholder: "Enter preventive action taken (action plan)",
        errorMessage: "Preventive action taken (Action Plan) is required",
        type: "input",
      },
      {
        key: "eErrorcorrected",
        label: "Error corrected in the system",
        placeholder: "Choose an error corrected in the system",
        errorMessage: "Error corrected in the system is required",
        type: "select",
        options: [
          {
            value: "Error corrected in the system",
            label: "Error corrected in the system",
          },
          {
            value: "Error cannot be corrected in the system",
            label: "Error cannot be corrected in the system",
          },
        ],
      },
      {
        key: "eValueoflossprevented",
        label: "$ value of Loss prevented",
        placeholder: "Enter $ value of Loss prevented",
        errorMessage: "",
        type: "input",
      },
      {
        key: "eErrorArea",
        label: "Error Area",
        placeholder: "Enter the Error Area",
        errorMessage: "Error Area is required",
        type: "input",
      },
      {
        key: "eErrorType",
        label: "Error Type",
        placeholder: "Enter the Error Type",
        errorMessage: "Error Type is required",
        type: "input",
      },
    ],
  },
  {
    key: "rcaDetails",
    title: "RCA Details",
    fields: [
      {
        key: "rcaLevelOne",
        label: "RCA Level One",
        placeholder: "Choose an RCA Level One",
        errorMessage: "RCA Level One is required",
        type: "select",
        options: [
          { value: "agent", label: "Agent" },
          { value: "client", label: "Client" },
          { value: "process", label: "Process" },
          { value: "technology", label: "Technology" },
        ],
      },
      {
        key: "rcaLevelTwo",
        label: "RCA Level Two",
        placeholder: "Choose RCA Level Two",
        errorMessage: "RCA Level Two is required",
        type: "select",
        optionsByParent: {
          agent: [
            {
              value: "unfocusedlossoffocus",
              label: "Unfocused / Loss of Focus",
            },
            {
              value: "insufficientproductknowledge",
              label: "Insufficient Product Knowledge",
            },
            { value: "communicationgap", label: "Communication Gap" },
            { value: "willbehavioralissue", label: "Will/Behavioral Issue" },
            { value: "rushed", label: "Rushed" },
            { value: "forgetfulness", label: "Forgetfulness" },
            { value: "wfh", label: "WFH" },
          ],
          client: [
            { value: "clientknowledgegap", label: "Knowledge Gap" },
            { value: "updatenotshared", label: "Update Not Shared" },
            { value: "nofeedbackmechanism", label: "No Feedback Mechanism" },
            {
              value: "communicationbreakdown",
              label: "Communication Breakdown",
            },
            { value: "unstructuredtraining", label: "Unstructured Training" },
            {
              value: "lackofreviewscoaching",
              label: "Lack of Reviews/Coaching",
            },
          ],
          process: [
            { value: "processknowledgegap", label: "Knowledge Gap" },
            { value: "sopdeficiency", label: "SOP Deficiency" },
            {
              value: "inadequatesupportcoaching",
              label: "Inadequate support/coaching",
            },
            {
              value: "notaskplanningtracking",
              label: "No task planning/tracking",
            },
            { value: "scenarionotcovered", label: "Scenario not covered" },
          ],
          technology: [
            { value: "technicalissue", label: "Technical Issue" },
            { value: "hardwareissues", label: "Hardware Issues" },
            { value: "accessories", label: "Accessories" },
            { value: "inadequaitsupport", label: "Inadequate IT Support" },
          ],
        },
      },
      {
        key: "rcaLevelThree",
        label: "RCA Level Three",
        placeholder: "Choose RCA Level Three",
        errorMessage: "RCA Level Three is required",
        type: "select",
        optionsByParent: {
          unfocusedlossoffocus: [
            {
              value: "unfocusedlossoffocusenvironmentalfactors",
              label: "Environmental Factors",
            },
            {
              value: "unfocusedlossoffocuspersonalfactors",
              label: "Personal Factors",
            },
            {
              value: "motivationandengagement",
              label: "Motivation and Engagement",
            },
          ],
          insufficientproductknowledge: [
            {
              value: "trainingrelatedcauses",
              label: "Training-Related Causes",
            },
            {
              value: "unawareofprocesschanges",
              label: "Unaware of process changes",
            },
          ],
          communicationgap: [
            { value: "poorcommunication", label: "Poor communication" },
            {
              value: "lessconfidenceinnewscenarios",
              label: "Less confidence in new scenarios",
            },
            {
              value: "unwillingtoclarifydoubts",
              label: "Unwilling to clarify doubts",
            },
            {
              value: "mixedorunclearmessages",
              label: "Mixed or unclear messages",
            },
            {
              value: "verbalcommunication",
              label: "Verbal communication",
            },
            {
              value: "backupagent",
              label: "Back up Agent",
            },
          ],
          willbehavioralissue: [
            {
              value: "poorattitude",
              label: "Poor attitude",
            },
            {
              value: "procrastination",
              label: "Procrastination",
            },
            {
              value: "lackofaccountability",
              label: "Lack of accountability",
            },
            {
              value: "notserioustowardresponsibilities",
              label: "Not serious toward responsibilities",
            },
            {
              value: "healthemotionalstress",
              label: "Health / Emotional Stress",
            },
          ],
          rushed: [
            { value: "negligence", label: "Negligence" },
            {
              value: "timepressuredeadlineworkload",
              label: "Time pressure/Deadline/ Workload",
            },
          ],
          forgetfulness: [
            {
              value: "updatesentviachatonly",
              label: "Update sent via chat only",
            },
            {
              value: "excessivemultitasking",
              label: "Excessive multitasking",
            },
            {
              value: "forgetfulnesspersonalfactors",
              label: "Personal Factors",
            },
          ],
          wfh: [
            { value: "singlescreen", label: "Single Screen" },
            { value: "electricityinternet", label: "Electricity / Internet" },
            {
              value: "wfhenvironmentalfactors",
              label: "Environmental Factors",
            },
          ],
          clientknowledgegap: [
            { value: "sopdeviation", label: "SOP deviation" },
            { value: "unclearrequirements", label: "Unclear Requirements" },
          ],
          updatenotshared: [
            {
              value: "teamunawareofnewflow",
              label: "Team unaware of new flow",
            },
            {
              value: "noformalupdateprocess",
              label: "No Formal Update Process",
            },
          ],
          nofeedbackmechanism: [
            {
              value: "noclarityonerrorsimprovements",
              label: "No clarity on errors/improvements",
            },
            {
              value: "nofeedbackchannelsestablished",
              label: "No Feedback Channels Established",
            },
          ],
          communicationbreakdown: [
            { value: "delayinresponse", label: "Delay in response" },
            {
              value: "misinterpretationofinformation",
              label: "Misinterpretation of Information",
            },
          ],
          unstructuredtraining: [
            { value: "incompletetraining", label: "Incomplete training" },
            {
              value: "nodefinedtrainingplan",
              label: "No Defined Training Plan",
            },
          ],
          lackofreviewscoaching: [
            {
              value: "lackofperformancefeedback",
              label: "Lack of performance feedback",
            },
            {
              value: "infrequentornoperformancereviews",
              label: "Infrequent or No Performance Reviews",
            },
          ],
          processknowledgegap: [
            { value: "sopnotdefined", label: "SOP not defined" },
            {
              value: "poorknowledgetransfer",
              label: "Poor knowledge transfer",
            },
            {
              value: "inadequatedocumentation",
              label: "Inadequate Documentation",
            },
          ],
          sopdeficiency: [
            { value: "sopnotavailable", label: "SOP not available" },
            {
              value: "sopsnotupdatedregularly",
              label: "SOPs Not Updated Regularly",
            },
          ],
          inadequatesupportcoaching: [
            {
              value: "taskexecutionconfusion",
              label: "Task execution confusion",
            },
            {
              value: "lackofmentorshipprogram",
              label: "Lack of Mentorship Program",
            },
          ],
          notaskplanningtracking: [
            { value: "notimeownership", label: "No time ownership" },
            {
              value: "absenceoftaskmanagementtools",
              label: "Absence of Task Management Tools",
            },
          ],
          scenarionotcovered: [
            {
              value: "unaddressededgecases",
              label: "Unaddressed edge cases",
            },
            {
              value: "lackofcontingencyplans",
              label: "Lack of Contingency Plans",
            },
          ],
          technicalissue: [
            { value: "systembugsglitches", label: "System bugs/glitches" },
            {
              value: "systemdowntimeoutages",
              label: "System downtime/outages",
            },
          ],
          hardwareissues: [
            {
              value: "performanceinternetissues",
              label: "Performance/internet issues",
            },
            { value: "serverissues", label: "Server issues" },
            { value: "agingequipment", label: "Aging Equipment" },
          ],
          accessories: [
            {
              value: "keyboardmousemonitorissues",
              label: "Keyboard/Mouse/Monitor issues",
            },
            {
              value: "incompatibledevices",
              label: "Incompatible Devices",
            },
          ],
          inadequaitsupport: [
            {
              value: "lackoftroubleshooting",
              label: "Lack of troubleshooting",
            },
            {
              value: "slowresponsetime",
              label: "Slow Response Time",
            },
          ],
        },
      },
      {
        key: "rcaLevelFour",
        label: "RCA Level Four",
        placeholder: "Choose RCA Level Four",
        errorMessage: "RCA Level Four is required",
        type: "select",
        optionsByParent: {
          unfocusedlossoffocusenvironmentalfactors: [
            {
              value: "excessivenoiseordistractionsinthe workplace",
              label: "Excessive noise or distractions in the workplace",
            },
            {
              value: "poorlightingoruncomfortable workspace",
              label: "Poor lighting or uncomfortable workspace",
            },
            {
              value: "frequentinterruptionsemailscallscoworkers",
              label: "Frequent interruptions (emails, calls, coworkers)",
            },
          ],
          unfocusedlossoffocuspersonalfactors: [
            {
              value: "fatigueorlackofsleep",
              label: "Fatigue or lack of sleep",
            },
            {
              value: "stressanxietyorpersonalissues",
              label: "Stress, anxiety, or personal issues",
            },
            {
              value: "healthproblemsorpoornutrition",
              label: "Health problems or poor nutrition",
            },
          ],
          motivationandengagement: [
            {
              value: "lackofinterestorpassioninthework",
              label: "Lack of interest or passion in the work",
            },
            {
              value: "feelingundervaluedorunrecognized",
              label: "Feeling undervalued or unrecognized",
            },
            {
              value: "pooralignmentbetweenpersonalvaluesandjobrole",
              label: "Poor alignment between personal values and job role",
            },
          ],
          trainingrelatedcauses: [
            {
              value: "insufficienttimefortraining",
              label: "Insufficient Time for Training",
            },
            {
              value: "nostructuredonboardingprogram",
              label: "No structured onboarding program",
            },
            {
              value: "sopnotrevisedafterupdates",
              label: "SOP not revised after updates",
            },
            {
              value: "newscenariosrareoccurredscenarios",
              label: "New Scenarios/ rare occurred scenarios",
            },
          ],
          unawareofprocesschanges: [
            {
              value: "missedupdatemeetingssopnotfollowed",
              label: "Missed update meetings, SOP not followed",
            },
          ],
          poorcommunication: [
            {
              value: "productupdatesnotsharedpromptly",
              label: "Product updates not shared promptly",
            },
          ],
          lessconfidenceinnewscenarios: [
            {
              value: "languagebarrierpoorcommunicationlackofunderstanding",
              label:
                "Language barrier / Poor communication / Lack of understanding",
            },
          ],
          unwillingtoclarifydoubts: [
            {
              value: "reluctancetoaskquestionsoradmitconfusion",
              label: "Reluctance to ask questions or admit confusion",
            },
            {
              value: "poorrelationshipwithsupervisors",
              label: "Poor relationship with supervisors",
            },
            {
              value: "lackofinterestorpassioninthework",
              label: "Lack of interest or passion in the work",
            },
          ],
          mixedorunclearmessages: [
            {
              value: "inconsistentinformationsharedpoorlisteningskills",
              label: "Inconsistent information shared, Poor listening skills",
            },
          ],
          verbalcommunication: [
            {
              value: "misinterpretedtheinformationupdateshared",
              label: "Misinterpreted the information/update shared",
            },
          ],
          backupagent: [
            {
              value: "noproperupdateoftaskbyprocessoragentaligned",
              label: "No Proper update of Task by Processor/Agent aligned",
            },
          ],
          poorattitude: [
            {
              value: "negativemindsetresistancetochange",
              label: "Negative mindset, resistance to change",
            },
            { value: "overconfidence", label: "Overconfidence" },
          ],
          procrastination: [
            {
              value: "delayingtasksduetofearoffailureorlowinterest",
              label: "Delaying tasks due to fear of failure or low interest",
            },
          ],
          lackofaccountability: [
            {
              value: "avoidingresponsibilityblamingothers",
              label: "Avoiding responsibility, blaming others",
            },
          ],
          healthemotionalstress: [
            {
              value: "anxietyburnoutdisengagement",
              label: "Anxiety, burnout, disengagement",
            },
          ],
          notserioustowardresponsibilities: [
            {
              value: "feelsworkisunimportantorunrewarding               ",
              label: "Feels work is unimportant or unrewarding              ",
            },
            { value: "lackofmotivation", label: "Lack of motivation" },
          ],
          negligence: [
            { value: "hastecarelessness", label: "Haste /carelessness" },
          ],
          timepressuredeadlineworkload: [
            { value: "lastminuterush", label: "Last-minute rush" },
            { value: "poortimemanagement", label: "Poor time management" },
            {
              value: "stressfromleadershippushingforspeedoverquality",
              label: "Stress from leadership pushing for speed over quality",
            },
            {
              value: "highworkloadorunderstaffing",
              label: "High workload or understaffing",
            },
          ],
          updatesentviachatonly: [
            {
              value: "nodocumentationofupdate",
              label: "No documentation of update",
            },
          ],
          excessivemultitasking: [
            { value: "urgentworkcamealong", label: "Urgent work came along" },
            { value: "understaffing", label: "Understaffing" },
          ],
          forgetfulnesspersonalfactors: [
            { value: "stressoranxiety", label: "Stress or anxiety" },
            {
              value: "fatigueorlackofsleep",
              label: "Fatigue or lack of sleep",
            },
          ],
          singlescreen: [
            {
              value: "unabletocopupwithmultipletabs",
              label: "Unable to cop up with Multiple Tabs",
            },
          ],
          electricityinternet: [{ value: "disruption", label: "Disruption" }],
          wfhenvironmentalfactors: [
            {
              value: "excessivenoiseordistractions",
              label: "Excessive noise or distractions",
            },
            {
              value: "uncomfortableworkspace",
              label: "Uncomfortable workspace",
            },
          ],
          sopdeviation: [
            { value: "outdatedprocedures", label: "Outdated procedures" },
          ],
          unclearrequirements: [
            {
              value: "poorcommunicationofneeds",
              label: "Poor Communication of Needs",
            },
          ],
          teamunawareofnewflow: [
            {
              value: "missedcommunicationinfosilos",
              label: "Missed communication, info silos",
            },
          ],
          noformalupdateprocess: [
            {
              value: "lackofscheduledclientcommunication",
              label: "Lack of Scheduled Client Communication",
            },
          ],
          noclarityonerrorsimprovements: [
            {
              value: "lackofmetricsnoimprovementcycle",
              label: "Lack of metrics, no improvement cycle",
            },
          ],
          nofeedbackchannelsestablished: [
            {
              value: "absenceoffeedbacktoolsorplatforms",
              label: "Absence of Feedback Tools or Platforms",
            },
          ],
          delayinresponse: [
            {
              value: "lateemailsslowfeedback",
              label: "Late emails, slow feedback",
            },
          ],
          misinterpretationofinformation: [
            {
              value: "lackofclarificationprocesses",
              label: "Lack of Clarification Processes",
            },
          ],
          incompletetraining: [
            {
              value: "patchyonboardingnofollowup",
              label: "Patchy onboarding, no follow-up",
            },
          ],
          nodefinedtrainingplan: [
            {
              value: "lackoftrainingownership",
              label: "Lack of Training Ownership",
            },
          ],
          lackofperformancefeedback: [
            {
              value: "lowmoralelackofrecognition",
              label: "Low morale, lack of recognition",
            },
          ],
          infrequentornoperformancereviews: [
            {
              value: "nostandardreviewcriteria",
              label: "No Standard Review Criteria",
            },
          ],
          sopnotdefined: [
            {
              value: "missinginsufficientdocumentation",
              label: "missinginsufficientdocumentation",
            },
          ],
          poorknowledgetransfer: [
            {
              value: "incompleteonboardingnohandsonpractice",
              label: "Incomplete onboarding, No Hands-On Practice",
            },
          ],
          inadequatedocumentation: [
            {
              value: "outdatedormissingdocuments",
              label: "Outdated or Missing Documents",
            },
          ],
          sopnotavailable: [
            {
              value: "documentoutdatedornotdistributedsourcesscattered",
              label: "Document outdated or not distributed / Sources scattered",
            },
          ],
          sopsnotupdatedregularly: [
            { value: "lackofreviewcycle", label: "Lack of Review Cycle" },
          ],
          taskexecutionconfusion: [
            { value: "noescalationpath", label: "No escalation path" },
          ],
          lackofmentorshipprogram: [
            {
              value: "limitedexperiencedstaffforguidance",
              label: "Limited Experienced Staff for Guidance",
            },
          ],
          notimeownership: [
            { value: "undefinedpriorities", label: "Undefined priorities" },
          ],
          absenceoftaskmanagementtools: [
            {
              value: "nodefinedownershipoftasktracking",
              label: "No Defined Ownership of Task Tracking",
            },
          ],
          unaddressededgecases: [
            {
              value: "frequentbreaksinworkflow",
              label: "Frequent breaks in workflow",
            },
          ],
          lackofcontingencyplans: [
            {
              value: "infrequentriskassessment",
              label: "Infrequent Risk Assessment",
            },
          ],
          systembugsglitches: [
            {
              value: "itticketdelaysrecurringbugsdelayedbug Fixes",
              label: "IT ticket delays, recurring bugs, Delayed Bug Fixes",
            },
          ],
          systemdowntimeoutages: [
            { value: "serviceinterruptions", label: "Service interruptions" },
          ],
          performanceinternetissues: [
            {
              value: "lowbandwidthlaggingdevices",
              label: "Low bandwidth, lagging devices",
            },
          ],
          serverissues: [
            {
              value: "hardwareupgradesdepreciation",
              label: "Hardware upgrades/depreciation",
            },
          ],
          agingequipment: [
            {
              value: "lackofscheduledmaintenance",
              label: "Lack of Scheduled Maintenance",
            },
          ],
          keyboardmousemonitorissues: [
            {
              value: "inputerrorsslowreplacement",
              label: "Input errors, slow replacement",
            },
          ],
          incompatibledevices: [
            {
              value: "nostandardizationofaccessories",
              label: "No Standardization of Accessories",
            },
          ],
          lackoftroubleshooting: [
            { value: "resourcingissues", label: "Resourcing issues" },
          ],
          slowresponsetime: [
            {
              value: "insufficientitstaffing",
              label: "Insufficient IT Staffing",
            },
          ],
        },
      },
    ],
  },
];
